module.exports = __webpack_public_path__ + "static/defaultBcg-56ff5c04201288531ff2cc661ef7b5d8.jpeg";